import React, { Component } from "react";
import { connect } from "react-redux";
import Back from "../../assets/Back";
import LargeCheckmark from '../../assets/CheckmarkLarge';
import Logo from "../../assets/Logo";
import * as actions from "../../state/actions/onboarding";

const supportUrl = `${process.env.REACT_APP_DOMAIN}/support`;
const dashboardUrl = `${process.env.REACT_APP_DASHBOARD_HOST}/dashboard`;

class ProcessingApplication extends Component {
  state = {
    invalidData: false,
    alreadyApplied: false,
    error: null
  };

  componentDidMount() {
    if (!window.onbeforeunload) {
      window.onbeforeunload = () => {
        return "Refreshing this page will cause you to lose your application progress. Continue?";
      };
    }

    const {
      user,
      step: { stepIsComplete },
      getDecision
    } = this.props;
    if (
      !user.email ||
      !user.firstName ||
      !user.lastName ||
      !user.phoneNumber ||
      !user.address ||
      !user.city ||
      !user.state ||
      !user.zip ||
      !user.dob ||
      !user.termsAccepted ||
      !user.ppAccepted
    ) {
      this.setState({ invalidData: true });
    } else {
      if (user.applicationStatus === "pending") {
        console.log("User is pending - allowed to resubmit");
      }
      if (!user.applicationStatus || user.applicationStatus === "pending" || user.applicationStatus === 'awaiting_user_response')
        getDecision();
      else {
        console.log("User already has application status!");
        if (user.applicationStatus === "preapproved") {
          console.log("User is already preapproved");
          this.props.updateStep("decision", { approved: false, pending: true });
        }
        if (user.applicationStatus === "rejected") {
          console.log("User is rejected - not allowed to resubmit");
        }
        this.props.updateStep("processingApplication", {
          stepIsComplete: true
        });
      }
      // this.props.checkStatusAndSubmit();
    }
  }

  componentWillUnmount() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }

  // The response comes wayy fast. Add a little delay to make the process
  // less jarring for the user.
  componentWillReceiveProps(nextProps) {
    if (nextProps.approved) {
      this.timeout = setTimeout(() => {
        this.timeout = null;
        if (this.props.approved) {
          window.onbeforeunload = null;
          window.location = dashboardUrl;
        }
      }, 1000);
    };
    if (nextProps.shouldShowHome) {
      window.onbeforeunload = null;
      if (window.location.pathname !== "/register/home") {
        this.props.history.push("/home");
        return;
      }
    };
    if (nextProps.step.stepIsComplete && !this.timeout) {
      this.timeout = setTimeout(() => {
        this.timeout = null;
        this.props.nextStep();
      }, 1000);
    }
  }

  handlePrevious = () => {
    this.props.updateStep("processingApplication", { error: null });
    this.props.previousStep();
  };

  render() {
    const { handlePrevious } = this;
    const { invalidData, alreadyApplied } = this.state;
    const {
      history: { push },
      step: { error },
      user = {}
    } = this.props;

    return (
      <>
        <div className="outerStack-mobile sm:outerStack px-10">
          {error || invalidData ?
            <div className="stepDescriptionText">
              Oops!
            </div> 
          :
            <>
              <div className="stepDescriptionText">
                You've successfully submitted your application.
              </div>
              <div className='flex items-center flex-col justify-center '>
                <LargeCheckmark className='mb-8' defaultHeight={140} defaultWidth={140}/>
                <div className='text-xl mx-5 text-center text-gray-600 mb-6'>We will notify you about the status of your application soon.</div>
              </div>
            </>
          }
          
          {alreadyApplied ? (
            <div>Your application is pending.</div>
          ) : invalidData && !this.props.noPropsCheck ? (
            <>
              {(user || {}).address ? (
                <div>
                  Your application contained invalid fields. Please hit "Back"
                  and make sure all of your information is entered correctly.
                </div>
              ) : (
                <div>
                  <div>
                    Your address may not have been entered correctly. Please hit
                    "Confirm Address" and make sure all of your information is
                    accurate.
                  </div>
                  <button
                    className={`continueButton`}
                    onClick={() => push("/address")}
                  >
                    Confirm Address
                  </button>
                </div>
              )}
              <div className="bottomBar">
                <div className="bottomBarText-mobile sm:bottomBarText">
                  <div>
                    <Back className="backButtonIcon" />
                    <input
                      type="button"
                      name="button"
                      value="Back"
                      className="backButton"
                      onClick={handlePrevious}
                    />
                    <div></div>
                  </div>
                </div>
              </div>
            </>
          ) : (
            <>  
              {error && (
                <div style={{ color: "red", position: "relative", top: 10 }}>
                  <span>
                    Something went wrong processing your application. A customer
                    support representative will be in touch with you shortly.
                    Feel free to{" "}
                  </span>
                  <a
                    href={supportUrl}
                    target="_blank"
                    style={{ color: "#28EBC1" }}
                  >
                    contact us
                  </a>
                  <span> anytime.</span>
                </div>
              )}
              <div className="innerStack">
                {/* <div className="textContainer" style={{ maxWidth: 240 }}>
                    {!error && (
                      <>
                        <span style={{ fontFamily: "HelveticaNeue-Bold" }}>
                          Fun fact:
                        </span>
                        <div>
                          Did you know with TomoCredit you can earn rewards in
                          crypto?
                        </div>
                      </>
                    )}
                  </div> */}
                <div className="bottomBar">
                  <div className="bottomBarText-mobile sm:bottomBarText">
                    <div>
                      {!error && !invalidData ? (
                        <input
                          type="button"
                          name="button"
                          value="Cancel"
                          className="backButton"
                          onClick={() => {
                            window.alert(
                              "You must wait for the current process to finish"
                            );
                          }}
                        />
                      ) : (
                        <>
                          <Back className="backButtonIcon" />
                          <input
                            type="button"
                            name="button"
                            value="Back"
                            className="backButton"
                            onClick={handlePrevious}
                          />
                        </>
                      )}
                      <div></div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </>
    );
  }
}

export default connect(
  state => ({
    user: state.register.user,
    step: state.register.processingApplication,
    approved: state.register.decision.approved
  }),
  actions
)(ProcessingApplication);
